import { createSelector } from 'reselect';
import get from 'lodash/get';
import { searchParametersSelector } from '~/Serp/selectors';

const indexSelector = state => state.index;
const isFetchingState = state => state.index.isFetching;
const errorState = state => state.index.error;
const numResultsState = state => state.index.numResults;

export const indexSeoState = createSelector(
  indexSelector,
  index => index.seo
);

export const indexSeoSelector = createSelector(
  indexSeoState,
  indexSeo => indexSeo
);

export const categoryIdSelector = createSelector(
  indexSelector,
  indexSeo => indexSeo.categoryId
);
export const letterSelector = createSelector(
  indexSelector,
  indexSeo => indexSeo.letter
);
export const isFetchingSelector = createSelector(
  isFetchingState,
  isFetching => isFetching
);

export const numResultsSelector = createSelector(
  numResultsState,
  numResults => numResults
);

export const errorSelector = createSelector(
  errorState,
  error => error
);

export const getSeoLinksByType = createSelector(
  [indexSeoState, searchParametersSelector],
  (seoLinks, searchParams) => {
    const what = get(searchParams, 'what_d');
    const where = get(searchParams, 'where');

    if (typeof what === 'string' && what.length > 0) {
      return seoLinks.filter(seoLink => seoLink.type === 'where');
    }

    if (typeof where === 'string' && where.length > 0) {
      return seoLinks.filter(seoLink => seoLink.type === 'what');
    }

    return [];
  }
);



// WEBPACK FOOTER //
// ./app/Index/selectors.js